
import React from 'react';
import _ from 'lodash';
import Moment from 'react-moment';
import {connect} from 'react-redux';
import { CardPlain } from '../../../widgets/Cards';
import { Graph2Data } from '../../../widgets/Graph';

class Glucose extends React.Component {

    // sorting data by date
    compareDate(a, b) {

        var key1 = a.date;
        var key2 = b.date;
    
        if (key1 > key2) {
            return -1;
        } else if (key1 === key2) {
            return 0;
        } else {
            return 1;
        }
    }


    //filter pathologys data by necessary data for this component
    tableData() {
        let FBS = _.filter(this.props.pathologys, item => item.name.includes("Fasting Glucose"));
        let A1C = _.filter(this.props.pathologys, item => item.name.includes("A1C"));
       
        var listArray = [];
        var i;

        //create initial value for listArray
        FBS.map( item => {
            listArray.push({date:item.date, FBS:item.value});
            return null;
        });
        
        //adding A1C to listArray by going through A1C, then find in listArray method
        for (i=0; i<A1C.length; i++) {
            // eslint-disable-next-line no-loop-func
            let obj = listArray.find(obj => obj.date === A1C[i].date);

            if (obj !== undefined) {
                obj.A1C = A1C.[i].value;
            } else {
                listArray.push({date:A1C[i].date, time: A1C[i].time, A1C:A1C[i].value})
            }
        }


        var listObj = listArray.sort(this.compareDate);
        return listObj;
    }

    // create table content
    tableContent() {

        var tableData = this.tableData();
        
        return tableData.map(val => {
      
            return (
                        <tr>
                            <td><Moment format='DD MMM YYYY'>{val.date}</Moment></td>
                            <td>{val.FBS}</td>
                            <td>{val.A1C}</td>
                        </tr>
                    )
            }) 
    }

    //create graph content

    graphContent() {
        var tableData = this.tableData();
        var tableRow = tableData.length;
        var i;
        var data;

        //Date data
        var date = [];
        for (i=0; i<tableRow; i++) {
            var getdata = tableData[i].date;
            var year = getdata.slice(0,4);
            var month = getdata.slice(5,7);
            var getdate = getdata.slice(8,10);
            data = getdate + "/" + month + "/" + year;
            date.push(data);
        }

        //FBS
        var FBS = [];
        for (i=0; i<tableRow; i++) {
            data = tableData[i].FBS;
            FBS.push(data);
        }

        //A1C
        var A1C = [];
        for (i=0; i<tableRow; i++) {
            data = tableData[i].A1C;
            A1C.push(data);
        }

        var legend = ['FBS','A1C'];

        return (
            <Graph2Data 
                date={date}
                legend={legend}
                data1={FBS}
                data2={A1C}
            />
            )

     }

    //combined content of table and graph

    Insidecontent() {

      this.graphContent();
   
        return (
            <div style={{display:"grid", gridTemplateRows:"30px 200px 120px" }}>
                
                Glucose
                {this.graphContent()}
              
                
                <div style={{overflowY:'scroll', width:'320px'}}>
                    <table className='lmtable'>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>FBS</th>
                                <th>HbA1C</th>
                            </tr>
                        </thead>
                        <tbody>
                                {this.tableContent()}
                        </tbody>
                    </table>
                </div>

            </div>
        )
    }

    // Render card
    render() {
        var monitors = this.props.monitors;
        if (monitors.some(e => e.panel === 'Glucose')) {
               return (
                    <CardPlain  title='Glucose' content={this.Insidecontent()} />
                )
        } else {
            return null;
        }
    }
}


const mapStateToProps = (state) => {
    return { 
        pathologys : state.pathologys,
        monitors : Object.values(state.monitors)
    }
}

export default connect(mapStateToProps)(Glucose);



